<template>
  <div class="content-wrap">
    <header class="content-header cf">
      <h3>{{ $t('meta.sensors') }}</h3>
      <div class="header-meta">
        <Link
          :to="`/company/containers/${containerData.uuid}/sensors/new`"
          class="button button-green button-small button-round"
          >{{ $t('containers.addSensor') }}</Link
        >
      </div>
    </header>
    <div v-if="containerData.sensors && containerData.sensors.length > 0" class="content-body">
      <Table>
        <template #header>
          <th>{{ $t('containers.sensorName') }}</th>
          <th>Hardware ID</th>
          <th>{{ $t('containers.sensorType') }}</th>
          <th>{{ $t('containers.sensorLastMeasuredAt') }}</th>
          <th></th>
        </template>
        <template #body>
          <tr v-for="sensor in containerData.sensors" :key="sensor.hardware_id">
            <td>{{ sensor.name || '-' }}</td>
            <td>{{ sensor.hardware_id }}</td>
            <td>{{ getSensorTypeLabel(sensor.sensor_type) }}</td>
            <td>{{ formattedFromDateTime(sensor.last_synced_at) }}</td>
            <td class="table__actions">
              <div
                v-if="(sensor.sensor_type == 'rhenus' || sensor.sensor_type == 'ad_hoc') && missingSensorSettings"
                class="missing-data"
              >
                <button class="table__action-button" href="#sensor-settings" @click="toSensorFields()">
                  <span class="material-icons">error</span>
                </button>
                <div class="description">
                  {{ $t('containers.missingSensorSettings') }}
                </div>
              </div>

              <button class="table__action-button" @click="fetchHistoricData(sensor.uuid)">
                <span class="material-icons">addchart</span>
              </button>
              <button class="table__action-button" @click="deleteSensor(sensor.uuid)">
                <span class="material-icons">delete</span>
              </button>
            </td>
          </tr>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import Table from '@/components/Table/index.vue'
import dateUtils from '@/components/mixins/dateUtils'

import containersApi from '@/api/container'
import sensorsApi from '@/api/sensors'

export default {
  name: 'CompanyContainerSensors',
  inject: ['showPopup'],
  emits: ['refreshData'],
  props: {
    container: {
      type: Object,
      required: true,
    },
  },
  components: {
    Table,
  },
  data() {
    return {
      containerData: this.container,
      highlightedMissingData: false,
      sensorTypes: [],
    }
  },
  mixins: [dateUtils],
  computed: {
    missingSensorSettings() {
      return this.containerData.type_distance_full === null || this.containerData.type_distance_empty === null
    },
  },
  watch: {
    container: {
      immediate: true,
      handler(newVal) {
        this.containerData = newVal
      },
      deep: true,
    },
  },
  methods: {
    getSensorTypeLabel(sensorType) {
      return this.sensorTypes.find(type => type.value == sensorType)?.label
    },
    async getSensorTypes() {
      this.sensorTypes = await sensorsApi.selectableSensorTypes()
    },
    toSensorFields() {
      this.highlightedMissingData = true
      setTimeout(() => {
        this.highlightedMissingData = false
      }, 5500)
    },
    async fetchHistoricData(sensorUuid) {
      const result = await containersApi.updateHistoricData(this.containerData.uuid, sensorUuid)
      // FIXME: show user feedback that the data is being fetched????
      console.log('result', result)
    },
    async deleteSensor(sensorUuid) {
      if (!(await this.showPopup({ content: this.$t('containers.deleteSensorConfirmation'), type: 'confirm' }))) return

      const result = await containersApi.sensors.delete(this.containerData.uuid, sensorUuid)
      if (result.success) {
        this.$emit('refreshData')
      }
    },
  },
  async created() {
    await this.getSensorTypes()
  },
}
</script>

<style lang="scss" scoped>
@import '../missing-data.scss';
.table.layout-fixed {
  .table__actions {
    overflow: visible;
  }
}
</style>
